import React from 'react';
import Input from "../../../PopUp/Input";
import BaseField from '../BaseField/BaseField';

type FractionFieldProps = {
  id?: string;
  title?: string;
  label?: string;
  displayName?: string;
  showTitle?: boolean;
  numerator?: string;
  denominator?: string;
  onChangeNumerator?: (value: string) => void;
  onChangeDenominator?: (value: string) => void;
  disabled?: boolean;
  isSelected?: boolean;
}

const FractionField = ({ id = 'fraction-field', title = 'Title', label = 'Fraction Field', displayName, showTitle = true, numerator = '', denominator = '', onChangeNumerator = () => {}, onChangeDenominator = () => {}, disabled = false, isSelected = false }: FractionFieldProps) => {
  const baseId = id || 'fraction-field';

  const handleNumeratorChange = (value: string) => {
    if (/^-?\d*$/.test(value) || value === '') {
      onChangeNumerator(value);
    }
  };

  const displayLabel = showTitle && displayName ? displayName : (showTitle ? label : '');

  return (
    <BaseField
      id={baseId}
      label={displayLabel}
      isSelected={isSelected}
      showTitle={showTitle}
    >
      <div id={`${baseId}-container`} className='tw-flex tw-items-center'>
        <Input
          id={`${baseId}-numerator`}
          className="tw-rounded-r-none"
          placeholder=""
          value={numerator}
          onChangeValue={handleNumeratorChange}
        />
      </div>
    </BaseField>
  );
};

export default FractionField;